'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// ./~/gray-matter/~/js-yaml/index.js
// module id = 252
// module chunks = 0